module.exports = __webpack_public_path__ + "static/media/amanprofile.6928a11d.png";